/* eslint-disable camelcase,dot-notation */
import { createActions } from 'redux-actions';

export const {
  setCardSelected,
  unselectAllCardsInStep,
  saveFormInfo,
  resetWizard,
} = createActions(
  {
    SET_CARD_SELECTED: (step, value) => ({
      step,
      value,
    }),
    UNSELECT_ALL_CARDS_IN_STEP: step => ({
      step,
    }),
    SAVE_FORM_INFO: value => ({
      value,
    }),
  },
  'RESET_WIZARD',
);



// WEBPACK FOOTER //
// ./src/store/actions/OnboardingRedesign/index.js